import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";
import { ReactComponent as Arrow } from "../../images/arrow.svg";
import useViewportWidth from "../../utils/useViewportWidth";

const AccordionBlock = ({
  data,
  selectAllDealer,
  setisOpenBonus,
  index,
  selectedAccordian,
  setSelectedAccordian,
  isOpenBonus,
  selectedDealerBonus,
  dealerBonusList,
  setMultiSelect,
  multiSelect,
}) => {
  console.log("ACCORDION DATA", isOpenBonus);
  const selectAllList = selectAllDealer;
  const viewportWidth = useViewportWidth();
  const [isOpen, setIsOpen] = useState(false);
  const [isMultiSelected, setIsMultiSelected] = useState(false);
  const [selectShow, setSelectShow] = useState(null);
  const [isMobile, setisMobile] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const GetSelectedDealerBonusDetails = (productId) => {
    const temp = selectedDealerBonus
      ?.filter((it) => it.product == productId)
      .pop();
    if (temp !== undefined && Object.keys(temp)?.length > 0) {
      const dealerBonus = dealerBonusList
        ?.filter((it) => it.id == temp.agent_bonus)
        .pop();
      return `${dealerBonus?.bonus} ${dealerBonus.bonus_type == 1 ? "%" : "$"
        } -  ${dealerBonus?.name}`;
    } else {
      return "Select an dealer bonus...";
    }
  };

  const toggleSelectAllProducts = (type) => {
    if (type === "check") {
      setIsMultiSelected(!isMultiSelected);
      setMultiSelect(
        isMultiSelected
          ? multiSelect?.filter((it) => it !== data.id)
          : [...multiSelect, data.id]
      );
      setSelectedProducts(
        isMultiSelected ? [] : data.products.map((_, index) => index)
      );
    } else {
      setIsMultiSelected(false);
      setMultiSelect(multiSelect?.filter((it) => it !== data.id));
      setSelectedProducts([]);
    }
  };

  const toggleAccordion = (id, type) => {
    if (selectedAccordian?.includes(id)) {
      type !== "check" &&
        setSelectedAccordian(selectedAccordian?.filter((it) => it !== id));
      toggleSelectAllProducts(type);
    } else {
      setSelectedAccordian([...selectedAccordian, id]);
    }
    setIsOpen(!isOpen);
  };

  const toggleSelectOpen = (productIndex) => {
    setSelectShow(productIndex);
  };

  const toggleSelectClose = () => {
    setSelectShow(null);
  };

  const toggleProduct = (value, index) => {
    console.log("CHECKED VALUE", value.target.checked);

    const updatedSelectedProducts = [...selectedProducts];
    if (updatedSelectedProducts.includes(index)) {
      const selectedIndex = updatedSelectedProducts.indexOf(index);
      updatedSelectedProducts.splice(selectedIndex, 1);
      if (updatedSelectedProducts?.length > 0) {
        setMultiSelect((prevArray) => [...prevArray]);
      } else {
        setMultiSelect((prevArray) => [
          ...prevArray?.filter((it) => it !== data.id),
        ]);
      }
      console.log("INSIDE", updatedSelectedProducts);
    } else {
      updatedSelectedProducts.push(index);
      setMultiSelect((prevArray) => [
        ...(prevArray?.includes(data.id)
          ? prevArray
          : prevArray.concat(data.id)),
      ]);
    }
    setSelectedProducts(updatedSelectedProducts);
  };

  useEffect(() => {
    if (selectAllList) {
      setIsMultiSelected(true);
      setSelectedProducts(data.products.map((_, index) => index));
    } else {
      setIsMultiSelected(false);
      setSelectedProducts([]);
    }
  }, [selectAllList]);
  useEffect(() => {
    if (multiSelect?.length < 1) {
      setSelectedProducts([]);
    }
  }, [multiSelect]);

  useEffect(() => {

    if (viewportWidth <= 767) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
  }, [viewportWidth]);
  console.log("selectShow", isMobile, selectShow, viewportWidth)


  return (
    <div className="accordion-block">
      <div className="accordion-head">
        <div className="agent-checkbox">
          <Checkbox
            onClick={() => {
              toggleSelectAllProducts("check");
              toggleAccordion(data?.id, "check");
            }}
            checked={
              isMultiSelected &&
              selectedAccordian?.includes(data?.id) &&
              multiSelect?.includes(data.id)
            }
          />
        </div>
        <button
          type="button"
          className="agent-head-section"
          onClick={() => toggleAccordion(data?.id, "accordian")}
        >
          <div className="agent-head-block">
            <div className="agent-logo">
              <img
                src={`https://api.ohhto.com/${data?.icon}`}
                alt="Agent logo"
              />
            </div>
            <div className="agent-info">
              <h2>{data.name}</h2>
              <div className="agent-info-block">
                <div className="agent-available-date">
                  <img
                    src="/images/fi_clock.svg"
                    alt="calendar"
                    className="mr-[5px]"
                  />
                  <h3>
                    Approval time: <strong>{data.approvaltimeinfo.name}</strong>
                  </h3>
                </div>
                <div className="agent-available-date">
                  <img
                    src="/images/fi_zap.svg"
                    alt="calendar"
                    className="mr-[5px]"
                  />
                  <h3>
                    Loan to Value:
                    <strong> {data.ltvinfo?.name}</strong>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          {isMobile ? (
            selectedProducts.length > 1 ? null : (
              <div className="product-count">
                <h4>({data.products.length})</h4>
                <span>
                  <Arrow />
                </span>
              </div>
            )
          ) : selectedProducts.length > 1 ? null : (
            <div className="product-count">
              <h4>Loan Product ({data.products.length})</h4>
              <span>
                <Arrow />
              </span>
            </div>
          )}
        </button>
        {multiSelect?.length == 1 && (
          <div
            className={`agent-common-select ${isMobile ? "popupAnim transform mobile-product-select " : ""
              } ${isMobile
                ? selectedProducts.length > 1
                  ? "visible"
                  : "invisible"
                : selectedProducts.length > 1
                  ? "visible"
                  : "hidden"
              } `}
          >
            <div className="input-group bonus-select">
              <label>Dealer Bonus</label>
              <button
                type="button"
                className="select_bonus_btn"
                onClick={() =>
                  setisOpenBonus({
                    ...isOpenBonus,
                    open: true,
                    isMultiSelect: true,
                    Product_Id: data?.id,
                  })
                }
                disabled={selectAllList}
              >
                Select an dealer bonus...
                <span className="select-arrow-right">
                  <Arrow />
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
      {selectedAccordian?.includes(data?.id) && (
        <div className="accordion-body">
          {data.products.map((product, index) => (
            <div
              className="accordion-list-section"
              key={index}
              style={{
                pointerEvents:
                  product.activeinterest?.agentbonusinfo !== null
                    ? "auto"
                    : "none",
                opacity:
                  product.activeinterest?.agentbonusinfo !== null
                    ? "none"
                    : "0.5",
              }}
            >
              {console.log("CHECKKK", product.activeinterest?.agentbonusinfo)}
              <div className="product-checkbox">
                <Checkbox
                  onClick={(value) => toggleProduct(value, index)}
                  checked={
                    selectedProducts.includes(index) &&
                    product.activeinterest?.agentbonusinfo !== null &&
                    multiSelect?.includes(data.id)
                  }
                />
              </div>
              <div className="accordion-list-block">
                <div className="product-list-group">
                  <div className="dealer-bonus-info">
                    <span>
                      {product.activeinterest
                        ? product.activeinterest?.interest
                        : "0"}
                      %
                    </span>
                  </div>
                  <div className="product-list-section">
                    <div className="product-list-block">
                      <div className="product-list">
                        <div className="product-img">
                          <img
                            src={`https://api.ohhto.com/${product?.icon}`}
                            alt="product"
                          />
                        </div>
                        <h5>{product.name}</h5>
                      </div>
                      <div className="product-list-info">
                        <p>
                          {product.categoryinfo?.name},{" "}
                          {product.motor_typeinfo?.name},{" "}
                          {product.schemeinfo?.name}, {product.typeinfo?.name},{" "}
                          {product.usageinfo?.name}
                        </p>
                        {/* <h6>No Bonus selected</h6> */}
                      </div>
                    </div>
                    {isMobile && (
                      <span
                        className="arrow-left"
                        onClick={() => toggleSelectOpen(index)}
                      >
                        <Arrow />
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={`product-bonus-select ${isMobile
                    ? "popupAnim transform mobile-product-select "
                    : "visible"
                    } ${isMobile
                      ? selectShow === index
                        ? "visible"
                        : "invisible"
                      : ""
                    }`}
                >
                  {isMobile && (

                    <span
                      className="arrow-right"
                      onClick={() => toggleSelectClose()}
                    >
                      <Arrow />
                    </span>
                  )}
                  {product.activeinterest?.agentbonusinfo !== null && (
                    <div className="input-group bonus-select">
                      <label>Dealer Bonus</label>
                      <button
                        type="button"
                        className="select_bonus_btn"
                        onClick={() => {
                          console.log(
                            "SELE INID CLICK",
                            product?.activeinterest?.agentbonusinfo !== null
                          );
                          setisOpenBonus({
                            ...isOpenBonus,
                            open: true,
                            product: product.id,
                            interest: product.activeinterest.id,
                            interest_bonus:
                              product?.activeinterest?.agentbonusinfo !== null
                                ? product?.activeinterest?.agentbonusinfo?.id
                                : "",
                            Product_Id: data?.id,
                            agent_bonus:
                              product?.activeinterest?.agentbonusinfo !== null
                                ? product?.activeinterest?.agentbonusinfo
                                  ?.agentbonuses?.length > 0
                                  ? product?.activeinterest?.agentbonusinfo?.agentbonuses?.map(
                                    (it) => it?.agent_bonus
                                  )
                                  : []
                                : [],
                          });
                        }}
                        disabled={isMultiSelected || selectAllList}
                      >
                        {product.activeinterest?.agentbonusinfo?.dealerbonus !==
                          null &&
                          product.activeinterest?.agentbonusinfo?.dealerbonus !==
                          undefined
                          ? selectedDealerBonus
                            ?.map((it) => it?.product)
                            ?.includes(product.id)
                            ? // ? GetSelectedDealerBonusDetails(product.id)
                            `${selectedDealerBonus
                              ?.filter((it) => it.product === product.id)
                              ?.map(
                                (ite) => ite?.agent_bonus?.length
                              )} Dealer Bonus Selected`
                            : ` ${product?.activeinterest?.agentbonusinfo?.agentbonuses?.length} Dealer Bonus Selected`
                          : `${selectedDealerBonus
                            ?.filter((it) => it.product === product.id)
                            ?.map(
                              (ite) => ite?.agent_bonus?.length
                            )} Dealer Bonus Selected`}
                        { }
                        <span className="select-arrow-right">
                          {/**
                         * ${
                              product.activeinterest.agentbonusinfo?.dealerbonus
                                ?.bonusinfo?.bonus
                            } ${
                              product.activeinterest.agentbonusinfo?.dealerbonus
                                ?.bonusinfo?.bonus_type == 1
                                ? "%"
                                : "$"
                            } -
                         */}
                          <Arrow />
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccordionBlock;
